<template>
  <div ref="element">
    <slot></slot>
  </div>
</template>

<script>
import { onBeforeUnmount, onMounted, ref } from '@vue/runtime-core';
export default {
  emits: ['intersect'],
  setup(props, context) {
    const element = ref(null);
    let observer = null;

    onMounted(() => {
      const obsOptions = {
        root: document,
        threshold: 0.1,
      };
      const obsCallback = (entries, observer) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          context.emit('intersect', entry);
          observer.unobserve(entry.target);
        }
      };
      observer = new IntersectionObserver(obsCallback, obsOptions);

      observer.observe(element.value.firstElementChild);
    });

    onBeforeUnmount(() => {
      // observer.disconnect();
      if (observer) {
        observer.unobserve(element.value.firstElementChild);
        observer = null;
      }
    });

    return { element };
  },
};
</script>
